import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import Logo from '../../img/Logotipo.png';
import home from '../../img/home3.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar light expand="md">
        <NavbarBrand href="/home">
          <img src="https://functionsnscwebapp.blob.core.windows.net/images/Logotipo.png" alt="Logotipo de NSC" />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar style={{ flexDirection: 'row-reverse' }}>
          <Nav className="ml-auto" navbar>
            <NavbarBrand href="/home">
              <img src={home} alt="Logotipo de NSC" />
            </NavbarBrand>
            <NavItem>
              <NavLink href="/about">¿Quiénes somos?</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/services">¿Qué ofrecemos?</NavLink>
            </NavItem>
            <NavItem>
              <UncontrolledDropdown setActiveFromChild>
                <DropdownToggle tag="a" className="nav-link w-color font-weight-bold" caret>
                  <strong>¿Qué compartimos?</strong>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem tag="a" href="/links">Ligas de interés</DropdownItem>
                  <DropdownItem tag="a" href="/alexa">Alexa</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </NavItem>
            <NavItem>
              <NavLink href="/contact">¿Cómo contactarnos?</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/FAQ">¿Qué nos preguntan?</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/media">Aviso Legal</NavLink>
            </NavItem>
            {/* Nuevo elemento para la página de Login */}
           
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
